module.exports = __webpack_public_path__ + "img/p5.b06aad0d.png";